import { Amplify } from "aws-amplify";
import { AppRegistry } from "react-native";
import environment from "setup/environment";

import App from "./App";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.USER_POOL_ID,
      userPoolClientId: environment.USER_POOL_WEB_CLIENT_ID,
    },
  },
});

AppRegistry.registerComponent("App", () => App);
AppRegistry.runApplication("App", {
  rootTag: document.getElementById("root"),
});
